/**
 * @description 活跃用户 activeUser
 * @author xiehan
 * @date 2019/11/27
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const activeUserBiz = new Logic()

activeUserBiz.queryHisDailyTml = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.activeUser.queryHisDailyTml,
    data: data
  })
}

/**
 * Created by xiehan on 2019/11/27.
 * 活跃用户导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 */
activeUserBiz.exportActiveUser = function (fields, search, time, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.activeUser.queryHisDailyTml,
    fields: fields,
    search: search,
    time: time
  })
  exportTable.send(success, fail)
}

export default activeUserBiz
